import {useFeatureFlags} from "../../providers/FeatureFlagProvider/FeatureFlagProvider";
import {useGetIsArielEmployee} from "../Organization/useGetIsArielEmployee";

export const useIsDataQualityTabEnabled = () : boolean => {
    const featureFlags = useFeatureFlags();
    return featureFlags.includes("isDataQualityTabEnabled")
}